import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Severity } from '@sentry/react';
import { GUARANTEED, MAYBE, NONE } from '../probability-of-bug';
import { UNKNOWN } from '../service';
import { responsibleServiceIncludesCommerceLibraries } from '../service/utils';

/**
 * Keep in mind what we're really using Sentry's "severity" not as a metric for severity but
 * for colour coding (more red = More you should go take a look at the log)
 */
export var calculateSeverityFromTags = function calculateSeverityFromTags(_ref) {
  var probabilityOfBug = _ref.probabilityOfBug,
      responsibleService = _ref.responsibleService;

  switch (probabilityOfBug) {
    case GUARANTEED:
      if (responsibleServiceIncludesCommerceLibraries(responsibleService)) {
        return Severity.Critical;
      }

      return Severity.Error;

    case MAYBE:
      return Severity.Warning;

    case NONE:
      return Severity.Log;

    default:
      // Should never happen so sending critical :3
      return Severity.Critical;
  }
};
var severityOrdering = new Map([[Severity.Fatal, 0], [Severity.Critical, 1], [Severity.Error, 2], [Severity.Warning, 3], [Severity.Info, 4], [Severity.Log, 5], [undefined, 6]]);
export var pickWorstSeverity = function pickWorstSeverity(severity1, severity2) {
  if (severityOrdering.get(severity1) <= severityOrdering.get(severity2)) {
    return severity1;
  }

  return severity2;
};
export var withTelemetryInfoScopeContext = function withTelemetryInfoScopeContext(scopeContext) {
  var _scopeContext$tags$re;

  var tags = _objectSpread(_objectSpread({}, scopeContext.tags), {}, {
    responsibleService: (_scopeContext$tags$re = scopeContext.tags.responsibleService) !== null && _scopeContext$tags$re !== void 0 ? _scopeContext$tags$re : UNKNOWN
  });

  return _objectSpread(_objectSpread({}, scopeContext), {}, {
    tags: tags,
    level: calculateSeverityFromTags(tags)
  });
};